import { Component } from '@angular/core';
import { GoogleTranslateComponent } from '../../../../google-translate/google-translate.component';
import { FontSelectorComponent } from './font-selector/font-selector.component';

@Component({
  selector: 'ppl-footer',
  standalone: true,
  imports: [GoogleTranslateComponent, FontSelectorComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {

}
